<div class="app-version-container">
  <!-- Android Column -->
  <div class="column">
    <h3 class="platform-header">Android</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Latest Version</mat-label>
        <input matInput [(ngModel)]="androidVersion" placeholder="Enter Android version" aria-label="Enter Android version" required>
        <mat-error *ngIf="!androidVersion">Version is required</mat-error>
      </mat-form-field>
    </div>
    <div class="form-row checkbox-row">
      <mat-checkbox [(ngModel)]="androidDowntimeActive" aria-label="Android downtime active">Downtime Active</mat-checkbox>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Downtime Start</mat-label>
        <input matInput [ngxMatDatetimePicker]="androidStartPicker" [(ngModel)]="androidDowntimeStart" [disabled]="!androidDowntimeActive" aria-label="Android downtime start">
        <mat-datepicker-toggle matSuffix [for]="androidStartPicker"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #androidStartPicker>
      </ngx-mat-datetime-picker>
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Downtime End</mat-label>
        <input matInput [ngxMatDatetimePicker]="androidEndPicker" [(ngModel)]="androidDowntimeEnd" [disabled]="!androidDowntimeActive" aria-label="Android downtime end">
        <mat-datepicker-toggle matSuffix [for]="androidEndPicker"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #androidEndPicker></ngx-mat-datetime-picker>
      </mat-form-field>
    </div>
    <div class="form-row">
      <button mat-raised-button color="primary" (click)="saveData('android')" aria-label="Save Android data">Save</button>
    </div>
  </div>

  <!-- iOS Column -->
  <div class="column">
    <h3 class="platform-header">iOS</h3>
    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Latest Version</mat-label>
        <input matInput [(ngModel)]="iosVersion" placeholder="Enter iOS version" aria-label="Enter iOS version" required>
        <mat-error *ngIf="!iosVersion">Version is required</mat-error>
      </mat-form-field>
    </div>
    <div class="form-row checkbox-row">
      <mat-checkbox [(ngModel)]="iosDowntimeActive" aria-label="iOS downtime active">Downtime Active</mat-checkbox>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Downtime Start</mat-label>
        <input matInput [ngxMatDatetimePicker]="iosStartPicker" [(ngModel)]="iosDowntimeStart" [disabled]="!iosDowntimeActive" aria-label="iOS downtime start">
        <mat-datepicker-toggle matSuffix [for]="iosStartPicker"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #iosStartPicker></ngx-mat-datetime-picker>
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Downtime End</mat-label>
        <input matInput [ngxMatDatetimePicker]="iosEndPicker" [(ngModel)]="iosDowntimeEnd" [disabled]="!iosDowntimeActive" aria-label="iOS downtime end">
        <mat-datepicker-toggle matSuffix [for]="iosEndPicker"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #iosEndPicker></ngx-mat-datetime-picker>
      </mat-form-field>
    </div>
    <div class="form-row">
      <button mat-raised-button color="primary" (click)="saveData('ios')" aria-label="Save iOS data">Save</button>
    </div>
  </div>
</div>
